import { Button, Form, Input } from 'antd';
import { useNavigate } from 'react-router-dom';

interface LoginChangePasswordProps {
  onFinish: (data: { confirmPassword: string; password: string }) => void;
}

export const LoginChangePassword = ({ onFinish }: LoginChangePasswordProps) => {
  const navigate = useNavigate();
  const [form] = Form.useForm();

  return (
    <Form
      form={form}
      name='login'
      className='space-y-4'
      onFinish={onFinish}
      layout='vertical'
      size='large'
    >
      <Form.Item
        label='Nova senha'
        name='password'
        rules={[
          {
            required: true,
            message: 'A senha é obrigatória',
          },
        ]}
      >
        <Input.Password placeholder='Nova senha' />
      </Form.Item>
      <Form.Item
        label='Confirmar nova senha'
        name='confirmPassword'
        dependencies={['password']}
        rules={[
          {
            required: true,
            message: 'A confirmação de senha é obrigatória',
          },
          {
            min: 8,
            message: 'A senha deve ter no mínimo 8 caracteres',
          },
          {
            pattern: /[0-9]/,
            message: 'A senha deve conter pelo menos um dígito',
          },
          {
            pattern: /[a-z]/,
            message: 'A senha deve conter pelo menos uma letra minúscula',
          },
          {
            pattern: /[A-Z]/,
            message: 'A senha deve conter pelo menos uma letra maiúscula',
          },
          {
            pattern: /[!@#$%^&*(),.?":{}|<>]/,
            message: 'A senha deve conter pelo menos um caractere de pontuação',
          },
          ({ getFieldValue }) => ({
            validator(_, value) {
              if (!value || getFieldValue('password') === value) {
                return Promise.resolve();
              }
              return Promise.reject(new Error('As senhas não coincidem'));
            },
          }),
        ]}
      >
        <Input.Password placeholder='Confirmar nova senha' />
      </Form.Item>
      <Form.Item>
        <Button type='primary' htmlType='submit' className='w-full'>
          Enviar
        </Button>
      </Form.Item>

      <div className='w-full text-center'>
        <button className='text-sm text-primary hover:underline' type='button' onClick={() => navigate('/login')}>
          Retornar para o login
        </button>
      </div>
    </Form>
  );
};
